import * as React from 'react';

import intro_placeholder from '../../../../assets/images/intro_placeholder.jpg';

import './ImageSidebar.scss';

export class ImageSidebar extends React.Component<{}> {
  public render() {
    return (
      <img src={intro_placeholder} className="partial-image-sidebar" />
    );
  }
}
